import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../../../../components/with-label/WithLabel';
import RadioGroup from '../../../../../../scout/components/radio-buttons/RadioGroup';
import DropdownWithIcons from '../../../../../../components/common-dropdown/DropdownWithIcons';
import useLanguagesOptions from '../../../../../../hooks/useLanguagesOptions';
import useFilterOptions from './useFilterOptions';
import CommonButton from '../../../../../../components/common-button/CommonButton';
import Icon from '../../../../../../icons/Icon';
import { ICONS } from '../../../../../../icons';
import { changeTableFilterBy, changeTableLanguage } from '../../../../../../redux/settings/scout/scoutSettingsReducer';

import scss from '../WritersList.module.scss';

const WritersFilters = () => {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const filterOptions = useFilterOptions();
  const languageOptions = useLanguagesOptions();

  const { language, filterBy } = useSelector((state) => state.scoutSettings.tableFilters);

  const formattedLanguagesOptions = useMemo(
    () => [
      {
        label: '',
        value: '',
      },
      ...languageOptions,
    ],
    [languageOptions],
  );

  const handleChangeFilter = useCallback(
    (newFilter) => {
      dispatch(changeTableFilterBy(newFilter));
    },
    [dispatch],
  );

  const handleChangeLanguage = useCallback(
    (newLanguage) => {
      dispatch(changeTableLanguage(newLanguage));
    },
    [dispatch],
  );

  const handleAddWriter = useCallback(() => {
    navigate('add-writer');
  }, [navigate]);

  return (
    <div className={scss.filtersWrapper}>
      <div className={scss.filters}>
        <WithLabel label={t('filterBy')} variant={LABEL_STYLES.CUSTOM} isBold extraClassName={scss.filterRow}>
          <RadioGroup options={filterOptions} value={filterBy} onChange={handleChangeFilter} />
        </WithLabel>

        <WithLabel variant={LABEL_STYLES.CUSTOM} label={t('language')} isBold extraClassName={scss.filterRow}>
          <DropdownWithIcons
            options={formattedLanguagesOptions}
            value={language}
            onSelect={handleChangeLanguage}
            placeholder={t('select')}
            isEmojiIcons
          />
        </WithLabel>
      </div>

      <CommonButton styleColor='secondary' maxWidth={120} onClick={handleAddWriter}>
        <Icon icon={ICONS.CirclePlus} />
        {t('add')}
      </CommonButton>
    </div>
  );
};

export default WritersFilters;
